import {
	SET_ACTIVE_CREDIT_TYPE,
} from '../actions/activeCreditTypeActions'

const initialState = {
	creditType: ''
}

export default function activeCreditTypeReducer(state = initialState, action) {
	switch(action.type) {

		case SET_ACTIVE_CREDIT_TYPE:
			// Set active credit type based on LUHN algorithm
			return {
				...state,
				creditType: action.payload,
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/activeCreditTypeReducers.js